const workData = [
    {
        key: "advancedAnalyst",
        heading: "Advanced Analyst",
        dateRange: "Oct 2021 - Jul 2022",
        organization: "EY Global Delivery Services India LLP",
        organizationLocation: "Gurgaon, Haryana, India",
        onLeft: true,
        responsibilities: [
            {
                key: "productDevelopment",
                heading: "Product Development - Client Side (Capital Edge)",
                items: [
                    "Assisted in growth and expansion of Capital Edge and was assigned to 3 client projects within the United States region, working on technologies like Angular, SQL Server, C#, Azure",
                    "Led migration of 3 client projects from an outdated SharePoint platform to a new Azure platform, participating in every stage from design to implementation to post-deployment",
                    "Managed projects for a period of 6 months due to a shortage of resources and was subsequently given expanded duties, ranging from Angular development to overseeing projects and even taking on tasks in NodeJS and C#",
                    "Supervised a team of 5 individuals, comprising both new hires and those involved in reporting and quality assurance, due to extensive knowledge and experience with the project",
                    "Created SQL Triggers for more than 10 tables, impacting both primary and foreign tables, and improved APIs written in C# (.Net) to enhance overall performance and customize product to meet specific client requirements"
                ]
            }
        ]
    },
    {
        key: "analyst",
        heading: "Analyst",
        dateRange: "Jul 2019 - Oct 2021",
        organization: "EY Global Delivery Services India LLP",
        organizationLocation: "Gurgaon, Haryana, India",
        onLeft: false,
        responsibilities: [
            {
                key: "analystProductDevelopment",
                heading: "Product Development - Client Side (Capital Edge)",
                items: [
                    "Worked on produced developed by EY for use in merger and acquisitions. The product helps clients keep track of activities from Day 1 to completion of transaction life cycle.",
                    "Responsible for modifying the product according to project and client needs. Worked on technologies/programming languages like Angular, SharePoint, etc.",
                    "Worked on Azure repositories, used Git commands, created branches, pipelines, releases, etc."
                ]
            }
        ]
    },
    {
        key: "trainee",
        heading: "Analyst Trainee / Consultant",
        dateRange: "Jan 2019 - Jul 2019",
        organization: "EY Global Delivery Services India LLP",
        organizationLocation: "Gurgaon, Haryana, India",
        onLeft: true,
        responsibilities: [
            {
                key: "internalSites",
                heading: "Internal Sites",
                items: [
                    "Designed a comprehensive website using Angular JS and SharePoint for EY teams located in Germany to demonstrate various offerings and strategies of EY and support sales pitch for different services to clients",
                    "Created a collaboration website alongside a senior developer acting as a platform for sharing ideas, designs, business scenarios, workflows, etc. which can be utilized to enhance EY business or optimize existing workflows",
                    "Completed configuration tasks for client projects situated in 2 distinct regions",
                    "Created custom media and content web parts on SharePoint using HTML, JavaScript, CSS to solve the needs of various users."
                ]
            }
        ]
    }
];

export default workData;